//  the process key/value pair specifies which document can be used in which process
// process: ["renewal", "newreg", "changeowner", "drivlicense"],
const { vehicleProcess } = require("../../constants")

const licenseTypes = {
  THREE_YEARS: "three-years-local",
  FIVE_YEARS: "five-years-local",
  INTERNATIONAL: "one-year-international",
}

const licenses = {
  [licenseTypes.THREE_YEARS]: {
    key: [licenseTypes.THREE_YEARS],
    name: "Drivers Licence Renewal (3 years)",
    connected: [],
    process: [vehicleProcess.D_LICENSE],
    processingTime: 60,
    price: { cost: 22000, price: 27000 },
  },
  [licenseTypes.FIVE_YEARS]: {
    key: [licenseTypes.FIVE_YEARS],
    name: "Drivers Licence Renewal (5 years)",
    connected: [],
    process: [vehicleProcess.D_LICENSE],
    processingTime: 60,
    price: { cost: 29000, price: 34000 },
  },
  [licenseTypes.INTERNATIONAL]: {
    key: [licenseTypes.INTERNATIONAL],
    name: "Drivers Licence (International)",
    connected: [],
    process: [vehicleProcess.D_LICENSE],
    processingTime: 3,
    price: { cost: 18000, price: 23000 },
  },
}

module.exports = { licenses, licenseTypes }
